import { useEffect } from "react";

const SITE = "https://petloc.co";
export const DEFAULT_TITLE = "petloc – QR-Sicherheitshalsband für Katzen & Hunde";
const DEFAULT_DESCRIPTION =
  "QR-Halsband und Mini-Anhänger für Katzen und Hunde: Wer dein Tier findet, scannt mit dem Handy und schickt dir Standort und Nachricht. Kein Akku, kein Abo, ab 10 €.";

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = href;
}

/**
 * Setzt Titel, Description, Canonical und OG-Tags pro Route (SPA). Öffentliche
 * Seiten geben `path` an; interne Seiten (Finder, App) setzen `noindex`.
 */
export function useSeo(opts: { title?: string; description?: string; path?: string; noindex?: boolean }) {
  const { title, description, path, noindex } = opts;
  useEffect(() => {
    const fullTitle = title ? `${title} | petloc` : DEFAULT_TITLE;
    const desc = description ?? DEFAULT_DESCRIPTION;
    const url = SITE + (path ?? "/");
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setCanonical(url);
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("name", "robots", "index, follow");
    };
  }, [title, description, path, noindex]);
}
